import produce from "immer";
import _ from "lodash";

import {
  CREATE_COMMENT_FAILURE,
  CREATE_COMMENT_REQUEST,
  CREATE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,
  DELETE_COMMENT_REQUEST,
  DELETE_COMMENT_SUCCESS,
  GET_COMMENTS_FAILURE,
  GET_COMMENTS_REQUEST,
  GET_COMMENTS_SUCCESS,
  GET_ONE_COMMENT_FAILURE,
  GET_ONE_COMMENT_REQUEST,
  GET_ONE_COMMENT_SUCCESS,
  SEARCH_COMMENTS_FAILURE,
  SEARCH_COMMENTS_REQUEST,
  SEARCH_COMMENTS_SUCCESS,
  SEARCH_COMMENT_HIERARCHY_FAILURE,
  SEARCH_COMMENT_HIERARCHY_REQUEST,
  SEARCH_COMMENT_HIERARCHY_SUCCESS,
  UPDATE_ACTIVE_COMMENT_FAILURE,
  UPDATE_ACTIVE_COMMENT_REQUEST,
  UPDATE_ACTIVE_COMMENT_SUCCESS,
  UPDATE_COMMENT_FAILURE,
  UPDATE_COMMENT_REQUEST,
  UPDATE_COMMENT_SUCCESS
} from "src/actions/commentActions";

import {ZERO_UUID} from "src/constants";

const initialState = {
  comments: [],
  comment: {},
  commentWithHierarchy: {},
  total: 0,
  loadingGetComments: false,
  loadingGetOneComment: false,
  loadingUpdateComment: false,
  loadingUpdatePermissionOfComment: false,
  loadingUpdateActiveComment: false,
  loadingDeleteComment: false,
  loadingCreateComment: false
};

const commentReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_COMMENT_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingCreateComment = true;
      });
    }

    case CREATE_COMMENT_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        if (response.parent_id === ZERO_UUID) {
          draft.comments = draft.comments.concat(response);
        } else if ("children" in draft.commentWithHierarchy[0]) {
          draft.commentWithHierarchy[0].children =
            draft.commentWithHierarchy[0].children.concat(response);
        } else {
          draft.commentWithHierarchy[0].children = [response];
        }
        draft.loadingCreateComment = false;
      });
    }

    case CREATE_COMMENT_FAILURE: {
      return produce(state, (draft) => {
        // Maybe Comment error
        draft.loadingCreateComment = false;
      });
    }

    case SEARCH_COMMENTS_REQUEST: {
      return produce(state, (draft) => {
        draft.comments = [];
        draft.loadingGetComments = true;
      });
    }

    case SEARCH_COMMENTS_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.comments = response;
        draft.loadingGetComments = false;
        draft.total = total;
      });
    }

    case SEARCH_COMMENTS_FAILURE: {
      return produce(state, (draft) => {
        // Maybe Comment error
        draft.loadingGetComments = false;
      });
    }

    // Case Get Comments
    case GET_COMMENTS_REQUEST: {
      return produce(state, (draft) => {
        draft.comments = [];
        draft.loadingGetComments = true;
      });
    }

    case GET_COMMENTS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.comments = response;
        draft.loadingGetComments = false;
      });
    }

    case GET_COMMENTS_FAILURE: {
      return produce(state, (draft) => {
        // Maybe Comment error
        draft.loadingGetComments = false;
      });
    }

    // Case Get One Comment
    case GET_ONE_COMMENT_REQUEST: {
      return produce(state, (draft) => {
        draft.comment = {};
        draft.loadingGetOneComment = true;
      });
    }

    case GET_ONE_COMMENT_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.comment = response;
        draft.loadingGetOneComment = false;
      });
    }

    case GET_ONE_COMMENT_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetOneComment = false;
      });
    }

    // Case Update Comment
    case UPDATE_COMMENT_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingUpdateComment = true;
      });
    }

    case UPDATE_COMMENT_SUCCESS: {
      const {response} = action.payload;
      const updateComment = _.map(state.comments, (i) => {
        if (i.id === response.id) return response;
        return i;
      });
      if (updateComment !== undefined && updateComment.length > 0) {
        return produce(state, (draft) => {
          draft.comments = updateComment;
          draft.loadingUpdateComment = false;
        });
      }
      return produce(state, (draft) => {
        draft.comments = [response];
        draft.loadingUpdateComment = false;
      });
    }

    case UPDATE_COMMENT_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingUpdateComment = false;
      });
    }

    // Case Update Active Comment
    case UPDATE_ACTIVE_COMMENT_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingUpdateActiveComment = true;
      });
    }

    case UPDATE_ACTIVE_COMMENT_SUCCESS: {
      const {response} = action.payload;
      const updateComment = _.map(state.comments, (i) => {
        if (i.id === response.id) return response;
        return i;
      });
      if (updateComment !== undefined && updateComment.length > 0) {
        return produce(state, (draft) => {
          draft.comments = updateComment;
          draft.loadingUpdateActiveComment = false;
        });
      }
      return produce(state, (draft) => {
        draft.comments = [response];
        draft.loadingUpdateActiveComment = false;
      });
    }

    case UPDATE_ACTIVE_COMMENT_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingUpdateActiveComment = false;
      });
    }

    // Case Delete Comment
    case DELETE_COMMENT_REQUEST: {
      return produce(state, (draft) => {
        draft.loadingDeleteComment = true;
      });
    }

    case DELETE_COMMENT_SUCCESS: {
      const {response} = action.payload;
      const deleteComment = _.filter(state.comments, (i) => i.id !== response);
      if (deleteComment !== undefined && deleteComment.length > 0) {
        return produce(state, (draft) => {
          draft.comments = deleteComment;
          draft.loadingDeleteComment = false;
        });
      }
      return produce(state, (draft) => {
        draft.comments = [];
        draft.loadingDeleteComment = false;
      });
    }

    case DELETE_COMMENT_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingDeleteComment = false;
      });
    }

    // Case Get Comment Hierarchy
    case SEARCH_COMMENT_HIERARCHY_REQUEST: {
      return produce(state, (draft) => {
        draft.commentWithHierarchy = {};
        draft.loadingGetOneComment = true;
      });
    }

    case SEARCH_COMMENT_HIERARCHY_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.commentWithHierarchy = response;
        draft.loadingGetOneComment = false;
      });
    }

    case SEARCH_COMMENT_HIERARCHY_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetOneComment = false;
      });
    }

    default: {
      return state; // We return the default state here
    }
  }
};

export default commentReducer;
